import { signOut } from "../../lib/auth-client";

// Routes that require authentication - user will be redirected on logout
export const AUTHENTICATED_ROUTES = [
	"/dashboard",
	"/settings",
	"/business/new",
	"/upgrade-success",
	"/upgrade-error",
];

// Check if current path requires authentication
export function isAuthenticatedRoute(pathname: string): boolean {
	// Check exact matches
	if (AUTHENTICATED_ROUTES.includes(pathname)) return true;
	// Check all dashboard sub-routes (e.g. /dashboard/brand/assets)
	if (pathname.startsWith("/dashboard/")) return true;
	return false;
}

export async function signOutAndNavigate(pathname: string) {
	const result = await signOut();

	if (result?.error) {
		throw new Error(result.error.message || "Failed to sign out");
	}

	if (isAuthenticatedRoute(pathname)) {
		window.location.href = "/";
		return;
	}

	window.location.reload();
}

export const dashboardNavItems = [
	{ label: "Generations", segment: "generations", to: "/dashboard/generations" },
	{ label: "Models", segment: "models", to: "/dashboard/models" },
	{ label: "Usage", segment: "usage", to: "/dashboard/usage" },
	{ label: "API Keys", segment: "api-keys", to: "/dashboard/api-keys" },
	{ label: "Members", segment: "members", to: "/dashboard/members" },
] as const;
